<template>
  <div id="content">
    <div class="product">
      <div style="padding-top:10px;padding-left: 5px;display: -webkit-flex;display: flex;-webkit-justify-content: space-between;justify-content: space-between;">
        <el-breadcrumb separator-class="el-icon-arrow-right"
                       style="width:60%;display: inline;">
          <el-breadcrumb-item :to="{ path: '/' }">{{$t('header.home')}}</el-breadcrumb-item>
          <el-breadcrumb-item><a @click="gotoallprod">{{$t('header.allproduct')}}</a></el-breadcrumb-item>
          <el-breadcrumb-item v-if="keywordinfo!=''">{{keywordinfo}}</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- <span style="float:right">sd</span> -->
        <div style="margin-right: 20px;">　　　{{$t('product.total')}}　{{products.TotalItems}}　{{$t('product.productcount')}}</div>
      </div>
      <div style="padding:10px; padding-left: 20px;margin-right: 20px;display: -webkit-flex;display: flex;background-color:gainsboro;">
        <div ref="refn"
             style="margin-right: 20px;color:red;"
             @click="gosort('refn')">{{$t('product.new')}}<i ref="refni"
             class="el-icon-caret-bottom"
             style="color:#409eff;"></i></div>
        <div ref="refh"
             style="margin-right: 20px;"
             @click="gosort('refh')">{{$t('product.hot')}}<i ref="refhi"
             class="el-icon-caret-bottom"
             style="color:gainsboro;"></i></div>
        <div ref="refp"
             style="margin-right: 20px;"
             @click="gosort('refp')">{{$t('product.price')}}<i ref="refpi"
             class="el-icon-caret-bottom"
             style="color:gainsboro;"></i></div>
        <el-checkbox v-model="prod_video"
                     @change="prod_video_change">{{$t('product.video')}}</el-checkbox>
        <!-- <div ref="refd"
             style="margin-right: 20px;"
             @click="gosort('refd')">尺寸<i ref="refdi"
             class="el-icon-caret-bottom"
             style="color:gainsboro;"></i></div> -->
      </div>
      <ul>
        <li v-for="p in products.Items"
            :key="p.id"
            style="display:block;text-align:left">
          <a :href="'/#/productdetail/'+p.ID"
             target="_blank">

            <!-- <el-popover placement="bottom-start"
                        trigger="hover">
              <div>
                <img :src="p.prod_image"
                     style="width:600px;height: 400px;">
              </div>
              <img slot="reference"
                   :src="p.prod_image">
            </el-popover> -->

            <img :src="p.prod_image"
                 alt="" />
          </a>
          <a v-if="$i18n.locale=='en'"
             :href="'/#/productdetail/'+p.ID"
             target="_blank">
            <div style="width:100%;height: 33px;"><span class="le">{{p.prod_numbers}}</span>
              <span style="float:right;text-align:right">{{p.prod_productL}}*{{p.prod_productW}}*{{p.prod_productH}}</span>
            </div>
            <div style="width:100%;height: 33px;margin-left: 0px;padding-left: 0px;"><span class="le">{{p.prod_enname}}</span></div>
          </a>
          <a v-else
             :href="'/#/productdetail/'+p.ID"
             target="_blank">
            <div style="width:100%;height: 33px;"><span class="le">{{p.prod_numbers}}</span>
              <span style="float:right;text-align:right">{{p.prod_productL}}*{{p.prod_productW}}*{{p.prod_productH}}</span>
            </div>
            <div style="width:100%;height: 33px;margin-left: 0px;padding-left: 0px;"><span class="le">{{p.prod_name}}</span></div>
          </a>
        </li>
      </ul>
    </div>
    <div>
      <div class="m b10">&nbsp;</div>
      <el-pagination background
                     layout="prev, pager, next"
                     :page-count="products.TotalPages"
                     @current-change="changePage">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import fetch from "@/utils/axios";
export default {
  components: {},
  name: "Product",
  data () {
    return {
      classs: [],
      products: {},
      page_index: 1,
      big_class: 0,
      keyword: {},
      keywordinfo: '',
      sortorder: 'refn',
      sortorderasc: true,
      prod_video: false
    };
  },
  created () {
    this.big_class = this.$route.params.id
    this.keyword = eval('(' + this.$route.params.key + ')');
  },
  mounted () {
    // 使用
    const params = { type: 1 }; // 参数
    fetch.post("/api/ApiProClass/GetAppHomeClass", params).then(
      (res) => {
        this.classs = res;
      },
      (error) => {
        alert(JSON.stringify(error));
      }
    );
    // const productparam = {page_index: this.page_index,key:this.keyword }; // 参数
    // if(this.big_class!=0)
    // {
    //   productparam.big_class=this.big_class;
    // }
    // fetch.post("/api/ApiProduct/QueryPageProductList", productparam).then(
    //   (res) => {
    //     this.products = res;
    //   },
    //   (error) => {
    //     alert(JSON.stringify(error));
    //   }
    // );
    this.changePage(1)


    if (this.keyword.hasOwnProperty("keyword")) {
      this.keywordinfo = this.keyword['keyword']
    }
    if (this.keyword.hasOwnProperty("bigclassid")) {
      const bp = { id: this.keyword['bigclassid'] }; // 参数
      fetch.post("/api/ApiProClass/Get", bp).then(
        (res) => {
          this.keywordinfo = res.name
        });
    };
    if (this.keyword.hasOwnProperty("smallclassid")) {
      const sbp = { id: this.keyword['smallclassid'] }; // 参数
      fetch.post("/api/ApiProClass/Get", sbp).then(
        (res) => {
          this.keywordinfo = res.name
        });
    };
  },
  methods: {
    prod_video_change () {
      this.changePage(1)
    },
    gosort (type) {
      if (type == this.sortorder) {
        this.sortorderasc = !this.sortorderasc;
      } else {
        this.sortorder = type;
        this.sortorderasc = true;
      }
      this.$refs.refn.setAttribute("style", "margin-right: 20px;color:#2c3e50;");
      this.$refs.refh.setAttribute("style", "margin-right: 20px;color:#2c3e50;");
      this.$refs.refp.setAttribute("style", "margin-right: 20px;color:#2c3e50;");
      // this.$refs.refd.setAttribute("style", "margin-right: 20px;color:#2c3e50;");
      this.$refs.refni.setAttribute("style", "color:gainsboro;");
      this.$refs.refhi.setAttribute("style", "color:gainsboro;");
      this.$refs.refpi.setAttribute("style", "color:gainsboro;");
      // this.$refs.refdi.setAttribute("style", "color:gainsboro;");
      if (type == 'refn') {
        this.$refs.refni.setAttribute("style", "color:#409eff");
        this.$refs.refn.setAttribute("style", "margin-right: 20px;color:red;");
        if (this.sortorderasc) {
          this.$refs.refni.setAttribute("class", "el-icon-caret-bottom");
        } else {
          this.$refs.refni.setAttribute("class", "el-icon-caret-top");
        }
      } else if (type == 'refh') {
        this.$refs.refhi.setAttribute("style", "color:#409eff");
        this.$refs.refh.setAttribute("style", "margin-right: 20px;color:red;");
        if (this.sortorderasc) {
          this.$refs.refhi.setAttribute("class", "el-icon-caret-bottom");
        } else {
          this.$refs.refhi.setAttribute("class", "el-icon-caret-top");
        }
      } else if (type == 'refp') {
        this.$refs.refpi.setAttribute("style", "color:#409eff");
        this.$refs.refp.setAttribute("style", "margin-right: 20px;color:red;");
        if (this.sortorderasc) {
          this.$refs.refpi.setAttribute("class", "el-icon-caret-bottom");
        } else {
          this.$refs.refpi.setAttribute("class", "el-icon-caret-top");
        }
        // } else if (type == 'refd') {
        //   this.$refs.refdi.setAttribute("style", "color:#409eff");
        //   this.$refs.refd.setAttribute("style", "margin-right: 20px;color:red;");
        //   if (this.sortorderasc) {
        //     this.$refs.refdi.setAttribute("class", "el-icon-caret-bottom");
        //   } else {
        //     this.$refs.refdi.setAttribute("class", "el-icon-caret-top");
        //   }
      }
      this.changePage(1)
      // class="el-icon-caret-bottom"
      //        style="color:#409eff;">
      // this.$refs.refni refhi refpi refdi
    },
    gotoallprod () {
      window.location.href = "/#/product";
      location.reload();
    },
    changePage (pageIndex) {
      if (this.keyword == null) {
        this.keyword = {}
      }
      this.keyword.prod_video = this.prod_video;
      // this.prod_video;
      const param = { page_index: pageIndex, page_size: 20, sortorder: this.sortorder, sortorderasc: this.sortorderasc, keyword: JSON.stringify(this.keyword) }
      fetch.post("/api/ApiProduct/QueryPageProductList", param).then(
        (res) => {
          this.products = res;
          window.scrollTo(0, 0)
        },
        (error) => {
          alert(JSON.stringify(error));
        }
      );
    }
  },
  scrollToBottom: function () {
    alert('scrollToBottom')
  }
};
</script>

<style>
#product {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 120px;
}

.nav_1 {
  width: 1190px;
  margin: 5px auto auto;
}
.nav_1 a {
  display: block;
  float: left;
  font-size: 14px;
  color: #333;
  width: 180px;
  height: 32px;
  text-align: center;
  line-height: 32px;
  background: #e6e6e6;
  border-bottom: 3px #dbdbdb solid;
  margin-right: 10px;
}
.nav_1 a:hover {
  background: #00a0e9;
  color: #fff;
  border-bottom: 3px #028fcf solid;
}
.nav_1 a.on {
  background: #00a0e9;
  color: #fff;
  border-bottom: 3px #028fcf solid;
}

.product {
  width: 1190px;
  overflow: hidden;
  margin: 5px auto auto;
}
.product ul {
  width: 1190px;
}
.product li {
  float: left;
  width: 262px;
  display: inline-block;
  padding: 9px;
  background: #f5f5f5;
  margin-top: 8px;
  margin-bottom: 8px;
  margin-right: 17px;
}
.product li img {
  display: block;
  border: 0;
  width: 262px;
  height: 176px;
  overflow: hidden;
}
.product li span {
  text-align: left;
  height: 32px;
  line-height: 32px;
  font-size: 14px;
  color: #333;
  overflow: hidden;
  /* margin-top: 4px; */
}
.product li em {
  display: block;
  text-align: right;
  font-style: normal;
  font-size: 12px;
  line-height: 24px;
}
.product li em a {
  color: #999;
}
.product li:hover {
  background: #00a0e9;
}
.product li:hover span {
  color: #fff;
}
.product li:hover em a {
  color: #fff;
}

.page {
  width: 1100px;
  margin: 40px auto;
  text-align: center;
  font-size: 12px;
  color: #333;
}
.page a {
  color: #333;
  padding: 7px 12px;
  border: 1px #ccc solid;
  margin: 0px 2px;
}
.page a:hover {
  border: 1px #01a4e9 solid;
  background: #01a4e9;
  color: #fff;
}
.page span {
  padding: 7px 12px;
  background: #01a4e9;
  color: #fff;
  border: 1px #01a4e9 solid;
  margin: 0px 2px;
}
</style>



// WEBPACK FOOTER //
// src/Product.vue